export default function initCart() {
  const cart = document.getElementById('cart-collapse');
  const backdrop = document.getElementById('cart-backdrop');

  if (cart) {
    cart.addEventListener('show.bs.collapse', () => {
      backdrop.classList.add('show');
    });

    cart.addEventListener('hide.bs.collapse', () => {
      backdrop.classList.remove('show');
    });
  }
}
